import type { ChatAttachmentDocumentCategory } from '~/types/ChatAttachment'

/**
 * Valeurs de catégorie documentaire acceptées par l'API conversation.
 */
export const CHAT_ATTACHMENT_DOCUMENT_CATEGORIES: readonly ChatAttachmentDocumentCategory[] = [
  'Bulletin',
  'CV',
  'CoverLetter',
  'Other',
] as const

/**
 * Couleurs d'accent par catégorie documentaire (alignées sur la maquette Lola).
 */
export const CHAT_ATTACHMENT_CATEGORY_COLORS: Record<ChatAttachmentDocumentCategory, string> = {
  Bulletin: '#03a0f1',
  CV: '#10b981',
  CoverLetter: '#f97316',
  Other: '#8a94a8',
}
